import React, { useState } from 'react';
import { Download } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from './ui/tabs';
import { Button } from './ui/button';

export const BankPaymentCodes = ({ data, orderNumber }) => {
  const [format, setFormat] = useState('hub3');
  const image = format === 'hub3' ? data.hub3Image : data.qrImage;
  return <section className="mt-6 border-t border-gray-200 pt-6" data-testid="bank-payment-codes">
    <h3 className="text-base sm:text-lg font-semibold mb-4" data-testid="bank-payment-codes-title">Kod za bankovnu uplatu</h3>
    <Tabs value={format} onValueChange={setFormat}>
      <TabsList className="grid grid-cols-2 w-full" data-testid="bank-code-format-tabs">
        <TabsTrigger value="hub3" data-testid="bank-code-hub3-tab">HUB3 barkod</TabsTrigger>
        <TabsTrigger value="epc" data-testid="bank-code-qr-tab">SEPA QR</TabsTrigger>
      </TabsList>
      <TabsContent value="hub3" className="mt-4" data-testid="bank-code-hub3-panel">
        <div className="bg-white border rounded p-2 sm:p-4"><img src={data.hub3Image} alt="HUB3 PDF417 barkod za ovu narudžbu" className="w-full h-auto object-contain" data-testid="bank-hub3-image" /></div>
      </TabsContent>
      <TabsContent value="epc" className="mt-4" data-testid="bank-code-qr-panel">
        <div className="bg-white border rounded p-3"><img src={data.qrImage} alt="EPC SEPA QR kod za ovu narudžbu" className="w-full max-w-[260px] aspect-square object-contain mx-auto" data-testid="bank-qr-image" /></div>
      </TabsContent>
    </Tabs>
    <Button variant="outline" className="mt-4 w-full" asChild>
      <a href={image} download={`${orderNumber}-${format}.png`} data-testid="bank-code-download"><Download size={16} /> Preuzmi kod za uplatu</a>
    </Button>
    <p className="text-xs text-gray-600 mt-3" data-testid="bank-code-safety-note">Podrška ovisi o bankovnoj aplikaciji. Prije potvrde provjerite primatelja, iznos i poziv na broj.</p>
  </section>;
};